import numeral from 'numeral';

/**
 * @description
 * Returns number | numeral string with the required currency format
 * If passed in 0, '0', '', null, it takes care to send back $0.00
 */

export enum CurrencyFormat {
  Comma = '0,00',
  CommaDecimal = '0,00.00',
}

export const currencyFormatter = (
  value: string | number | null | undefined,
  format: CurrencyFormat = CurrencyFormat.CommaDecimal
) => {
  const numeralValue = numeral(value);
  const numberFormatted = numeralValue?.format(format, Math.floor);

  return `$${numberFormatted}`;
};
